import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';
import { Field } from 'react-final-form';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Message } from '../../common/ui/message';
import { shouldShowValidationErrors } from '../../common/utils/form';
var fieldWrapperStyles = css({
  marginTop: "var(--ds-space-100, 8px)"
});
export function CreateField(_ref) {
  var id = _ref.id,
    name = _ref.name,
    label = _ref.label,
    isRequired = _ref.isRequired,
    validators = _ref.validators,
    validationHelpText = _ref.validationHelpText,
    testId = _ref.testId,
    children = _ref.children;
  var fieldId = id ? id : "link-create-field-".concat(name);
  return jsx(Field, {
    name: name,
    validate: function validate(value) {
      var _find;
      return (_find = (validators !== null && validators !== void 0 ? validators : []).find(function (validator) {
        return !validator.isValid(value);
      })) === null || _find === void 0 ? void 0 : _find.errorMessage;
    }
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    var isInvalid = shouldShowValidationErrors(meta);
    var submitError = meta.submitError,
      error = meta.error;
    var hasError = !!submitError || !!error;
    var showErrorMessage = hasError && isInvalid;
    var describedById = "".concat(fieldId, "-description");
    var errorMessageId = "".concat(fieldId, "-error");
    var ariaErrorMessage = showErrorMessage ? errorMessageId : undefined;
    return jsx("div", {
      css: fieldWrapperStyles,
      "data-testid": testId
    }, label && jsx(Label, {
      htmlFor: fieldId,
      id: "".concat(fieldId, "-label"),
      testId: "".concat(testId, "-label")
    }, label, isRequired && jsx(RequiredAsterisk, null)), children(_objectSpread(_objectSpread({}, input), {}, {
      fieldId: fieldId,
      isInvalid: isInvalid,
      isRequired: isRequired,
      'aria-errormessage': ariaErrorMessage,
      'aria-describedby': describedById
    })), jsx("div", {
      id: describedById
    }, !hasError && validationHelpText && jsx(Message, {
      testId: "".concat(testId, "-helper-message")
    }, validationHelpText), jsx("div", {
      "aria-live": "polite"
    }, showErrorMessage && jsx(Message, {
      id: errorMessageId,
      appearance: "error",
      testId: "".concat(testId, "-error-message")
    }, submitError || error))));
  });
}